import React, { useState } from "react";

export const countWords = (s) => (s || "").trim().split(/\s+/).filter(Boolean).length;

export default function ReadMore({ text, words = 60, testId = "read-more" }) {
  const [open, setOpen] = useState(false);
  const all = (text || "").trim().split(/\s+/).filter(Boolean);
  const long = all.length > words;
  const shown = open || !long ? text : all.slice(0, words).join(" ") + "…";
  return (
    <div>
      <p className="text-[#1A1F2C] leading-relaxed whitespace-pre-line break-words" data-testid={`${testId}-text`}>{shown}</p>
      {long && (
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="mt-2 text-sm font-medium text-[#C85A32] hover:underline"
          aria-expanded={open}
          data-testid={`${testId}-toggle`}
        >
          {open ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
}
